/**
 * La liste des collègues est-elle VRAIMENT bornée à ceux qui voient l'appel d'offres ?
 *
 * ## Pourquoi (décision PO n° 66 du 2026-10-03)
 *
 * `useDestinatairesDeLaTache` ne croise la liste des collègues avec
 * `useDesignablesSurLaConsultation` que si celle de l'AO est LUE en entier : en route, en échec
 * (403 sans droit de lire les AO, 404 pour un AO hors de la portée de la session) ou TRONQUÉE au
 * plafond de la route (`nonListes`), elle rend la liste entière — une liste incomplète ne prouve
 * pas l'absence, et le serveur juge. La console admin des tâches disait pourtant « Seuls les
 * collègues qui voient l'appel d'offres de ces tâches sont proposés » dès qu'un AO était commun
 * à la sélection : la phrase mentait dans ces trois cas, et le collègue proposé était refusé en
 * 422.
 *
 * `listeBorneeALAo` est la condition sous laquelle ce crochet borne la liste ; la phrase ne se
 * dit que sous elle. `useListeBorneeALAo` relit la MÊME requête (même clé de cache) : aucun
 * appel de plus.
 */

import { useDesignablesSurLaConsultation } from '@/components/shared/useDesignablesSurLaConsultation'

interface EtatDeLaListe {
    isLoading: boolean
    error: unknown
    nonListes: number
}

/** Vrai quand la liste de l'AO `tenderId` est lue en entier : elle borne alors les collègues. */
export function listeBorneeALAo(tenderId: string | null, etat: EtatDeLaListe): boolean {
    return tenderId !== null && !etat.isLoading && !etat.error && etat.nonListes === 0
}

export function useListeBorneeALAo(entityId: string | null, tenderId: string | null): boolean {
    const etat = useDesignablesSurLaConsultation({
        entityId: entityId ?? '',
        tenderId,
        enabled: tenderId !== null,
    })
    return listeBorneeALAo(tenderId, etat)
}
